import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import WidgetYoutube from './WidgetYoutube'
import WidgetEventCalendar from './WidgetEventCalendar'
import WidgetLatestPosts from './WidgetLatestPosts'
import WidgetFutureEvents from './WidgetFutureEvents'
import WidgetTodaysEvents from './WidgetTodaysEvents'

const SidebarDefault = () => {
  const { wp: data } = useStaticQuery(graphql`
    query DefaultSidebarQuery {
      wp {
        futureEvents: events(
          first: 5
          where: {
            scope: FUTURE
            status: PUBLISH
            language: DEFAULT
            orderby: {
              order: ASC
              field: START_DATE
            }
          }
        ) {
          nodes {
            ...EventFields
          }
        }

        latestPosts: posts(
          first: 5
          where: {
            status: PUBLISH
            language: DEFAULT
            orderby: {
              field: DATE
              order: DESC
            }
          }
        ) {
          nodes {
            ...PostFields
          }
        }
      }
    }
  `)

  return (
    <aside>
      <WidgetTodaysEvents />
      <WidgetEventCalendar />
      <WidgetFutureEvents events={data.futureEvents.nodes} />
      <WidgetYoutube />
      <WidgetLatestPosts posts={data.latestPosts.nodes} />
    </aside>
  )
}

export default SidebarDefault
